import { ThemeColors } from '~/themes/colors'

export interface SearchInputColors {
  Background: ThemeColors
  Border: ThemeColors
  BoxShadow_Selected: ThemeColors
  FontColor: {
    Placeholder: ThemeColors
  }
  Icons: {
    Search: ThemeColors
    Clear: {
      Stroke: ThemeColors
      Fill: ThemeColors
    }
  }
}

export const searchInputColors: SearchInputColors = {
  Background: {
    default: 'gray.100',
  },
  Border: {
    default: 'gray.800',
  },
  BoxShadow_Selected: {
    default: 'blue.300',
  },
  FontColor: {
    Placeholder: {
      default: 'gray.800',
    },
  },
  Icons: {
    Search: {
      default: 'gray.800',
    },
    Clear: {
      Stroke: {
        default: 'gray.100',
      },
      Fill: {
        default: 'gray.1300',
      },
    },
  },
}
